import { Tooltip } from "antd";

function CustomTooltip(props: { value: string }) {
  const { value } = props;

  return (
    <Tooltip
      destroyOnHidden
      // antd v6 renamed `showArrow` to `arrow`; the old prop is ignored.
      arrow={false}
      title={value}
      placement="bottomLeft"
      autoAdjustOverflow
      styles={{
        root: { padding: 0 },
        container: {
          border: "1px solid #d1d1d1",
          color: "#1f2426",
          fontSize: 12
        }
      }}
    >
      {value}
    </Tooltip>
  );
}

export default CustomTooltip;
